"use client";

import { FunnelIcon } from "@heroicons/react/24/outline";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Button,
  cn,
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@ubud-ui/react-ui-kit";
import { useState } from "react";
import { EducationFilter } from "./education-filter";
import { IndustryFilter } from "./industry-filter";
import { JkpPlatformFilter } from "./jkp-platform-filter";
import { JobFunctionFilter } from "./job-function-filter";
import { JobTypeFilter } from "./job-type-filter";
import { LocationFilter } from "./location-filter";
import { PhysicalConditionFilter } from "./physical-condition-filter";
import { PlatformFilter } from "./platform-filter";
import { SkillFilter } from "./skill-filter";

function FilterContainer({ path }: { path: string }) {
  return (
    <Accordion type="multiple" defaultValue={["location-filter", "job-type-filter"]}>
      <AccordionItem key="location-filter" value="location-filter">
        <AccordionTrigger className="leading-[140%]">Lokasi</AccordionTrigger>
        <AccordionContent>
          <LocationFilter path={path} />
        </AccordionContent>
      </AccordionItem>
      <AccordionItem key="job-type-filter" value="job-type-filter">
        <AccordionTrigger className="leading-[140%]">Tipe Pekerjaan</AccordionTrigger>
        <AccordionContent>
          <JobTypeFilter path={path} />
        </AccordionContent>
      </AccordionItem>
      <AccordionItem key="education-filter" value="education-filter">
        <AccordionTrigger className="leading-[140%]">Pendidikan</AccordionTrigger>
        <AccordionContent>
          <EducationFilter path={path} />
        </AccordionContent>
      </AccordionItem>
      <AccordionItem key="physical-condition-filter" value="physical-condition-filter">
        <AccordionTrigger className="leading-[140%]">Kondisi</AccordionTrigger>
        <AccordionContent>
          <PhysicalConditionFilter path={path} />
        </AccordionContent>
      </AccordionItem>
      <AccordionItem key="jkp-platform-filter" value="jkp-platform-filter">
        <AccordionTrigger className="leading-[140%]">Lowongan Kerja JKP</AccordionTrigger>
        <AccordionContent>
          <JkpPlatformFilter path={path} />
        </AccordionContent>
      </AccordionItem>
      <AccordionItem key="platform-filter" value="platform-filter">
        <AccordionTrigger className="leading-[140%]">Sumber Lowongan</AccordionTrigger>
        <AccordionContent>
          <PlatformFilter path={path} />
        </AccordionContent>
      </AccordionItem>
      <AccordionItem key="job-function-filter" value="job-function-filter">
        <AccordionTrigger className="leading-[140%]">Bidang Pekerjaan</AccordionTrigger>
        <AccordionContent>
          <JobFunctionFilter path={path} />
        </AccordionContent>
      </AccordionItem>
      <AccordionItem key="industry-filter" value="industry-filter">
        <AccordionTrigger className="leading-[140%]">Sektor</AccordionTrigger>
        <AccordionContent>
          <IndustryFilter path={path} />
        </AccordionContent>
      </AccordionItem>
      <AccordionItem key="skill-filter" value="skill-filter">
        <AccordionTrigger className="leading-[140%]">Keahlian</AccordionTrigger>
        <AccordionContent>
          <SkillFilter path={path} />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}

export function VacancyFilter({ path = "/lowongan-dalam-negeri/lowongan", titleClassName }: { path?: string; titleClassName?: string }) {
  const [isSheetOpen, setIsSheetOpen] = useState<boolean>(false);
  const handleToggleSheet = (open: boolean) => {
    setIsSheetOpen(open);
  };

  return (
    <>
      <div className="hidden md:block">
        <h4 className={cn("text-xl sm:text-2xl font-bold mb-4", titleClassName)}>Filter</h4>
        <hr className="border-gray-200 my-0" />
        <FilterContainer path={path} />
      </div>
      <div className="md:hidden">
        <Sheet open={isSheetOpen} onOpenChange={handleToggleSheet}>
          <SheetTrigger asChild>
            <Button variant={isSheetOpen ? "default" : "outline"} className="rounded-full" size="sm">
              <span>Filter</span>
              <FunnelIcon className="size-5 min-w-5" />
            </Button>
          </SheetTrigger>
          <SheetContent className="overflow-y-auto p-4" closeClassName="top-4 right-4" closeIconClassName="w-7 h-7" side="right">
            <SheetHeader>
              <SheetTitle className="text-left">Filter</SheetTitle>
              <div className="mt-6 text-left">
                <FilterContainer path={path} />
              </div>
            </SheetHeader>
          </SheetContent>
        </Sheet>
      </div>
    </>
  );
}
